import { getWindowLocation } from "./browser";
import { getSpaceIdFromPath as getSpaceIdFromPathCommon } from "gather-common/dist/src/public/utils";
import { Logger } from "./Logger";
import { matchPath } from "react-router-dom";
export function getInStudio() {
    const pathToParse = decodeURIComponent(getWindowLocation().pathname);
    const studioPattern = "/app/:room/:name/studio";
    const match = matchPath({
        path: studioPattern,
        end: true,
        caseSensitive: true,
    }, pathToParse);
    return !!match;
}
export function getInStudioMainApp() {
    const pathToParse = decodeURIComponent(getWindowLocation().pathname);
    const studioPattern = "/app/:room/:name/studioMainApp";
    const match = matchPath({
        path: studioPattern,
        end: true,
        caseSensitive: true,
    }, pathToParse);
    return !!match;
}
export function getSpaceIdFromPath(path) {
    const pathToParse = path || decodeURIComponent(getWindowLocation().pathname);
    return getSpaceIdFromPathCommon(pathToParse);
}
export function getAndAssertSpaceIdFromPath() {
    const spaceId = getSpaceIdFromPath();
    if (spaceId === null) {
        console.error("getAndAssertSpaceIdFromPath failed to find the spaceId!");
        return "";
    }
    return spaceId;
}
export const arrayJoinWithLast = (arr, regularSeparator, lastSeparator) => arr.slice(0, -1).join(regularSeparator) + (arr.length > 1 ? lastSeparator : "") + arr.slice(-1);
export const loadFont = (fontName, fontPath) => {
    const newFont = new FontFace(fontName, `url(${fontPath})`);
    newFont
        .load()
        .then((loadedFont) => {
        document.fonts.add(loadedFont);
    })
        .catch((e) => {
        Logger.error("Loading of font " + fontName + " located at " + fontPath + " failed.", e);
    });
};
export const simulateFocusChangeForTest = (_focused) => {
    throw new Error("simulateFocusChange should not be called outside of tests");
};
export const simulateVisibilityChangeForTest = (_status) => {
    throw new Error("simulateVisibilityChange should not be called outside of tests");
};
//# sourceMappingURL=utils.js.map